// betonijerry/src/utils/auth/sessionApi.js
// Server-side session revocation. Betonijerry logout was previously client-only
// (setAuth(null)); this blacklists the token via the shared betoni.online
// endpoint so a leaked token (XSS / shared browser) cannot be reused for its
// remaining lifetime — notably the 7-day admin token stashed while impersonating.

import { API_URL } from "src/utils/apiUrl";
import { authHeaders } from "src/utils/apiFetch";

/**
 * Blacklist a JWT server-side (POST /api/auth/logout). Call fire-and-forget from
 * logout — it must never block the (also 401-handler) logout path. Resolves to
 * the HTTP ok flag; a dead/expired token just comes back not-ok (harmless).
 * @param {string} token
 * @returns {Promise<boolean>}
 */
export async function revokeSession(token) {
  const res = await fetch(`${API_URL}/api/auth/logout`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
  });
  return res.ok;
}
